// extracted by mini-css-extract-plugin
module.exports = {"card":"verticalApplicationsCard-module--card--Fs91_","imageContainer":"verticalApplicationsCard-module--imageContainer--29UmW"};